"use strict";

var _construct = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/construct");

var _toConsumableArray = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/regenerator");

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(generateNodePortConstraints),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(generateNodeAlignmentConstraints);

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * These functions output gradients to induce certain properties on `Vector`s and `Node`s.
 * These gradients can function as 'soft' nudges  or 'hard' constraints depending on the learning
 * rate. A `constraint` function produces a gradient that has geometric meaning, i.e. a shift in
 * position, whereas a `nudge` function produces a gradient that matters more in direction than in
 * magnitude.
 */

var three_1 = require("three");

var optim_1 = require("../optim"); // Threshold for distance under which points are considered to be the same.


var kZeroThreshold = 1e-3;
/**
 * Constrains the Euclidean distance between points, optionally after projection onto an axis.
 * @param p
 *     Point vector.
 * @param q
 *     Point vector.
 * @param op
 *     Whether to make separation equal to (`=`), greater than or equal to (`>=`), or less than or
 *     equal to (`<=`) the specified distance.
 * @param distance
 *     Positive separation between `p` and `q`.
 * @param axis
 *     Axis onto which the separation is projected. Gradients will point in opposite directions
 *     along this axis. Sign/magnitude does not matter, i.e. [1, 0] is the same as [-2, 0].
 * @param masses
 *     Mass of a point determines its inertia, i.e. with more mass it moves less.
 * @returns
 *     Empty array (if already satisfied) or 2-array of gradients in order `[p, q]`.
 */

function constrainDistance(p, q, op, distance) {
  var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
      _ref$axis = _ref.axis,
      axis = _ref$axis === void 0 ? undefined : _ref$axis,
      _ref$masses = _ref.masses,
      masses = _ref$masses === void 0 ? [1, 1] : _ref$masses;

  var pq = new optim_1.Vector().subVectors(q, p);
  var v = axis ? new optim_1.Vector(axis[0], axis[1]).normalize() : pq.clone().normalize();
  var current = axis ? Math.abs(pq.dot(v)) : pq.length();
  if (op === '>=' && current >= distance + kZeroThreshold) return [];
  if (op === '<=' && current <= distance - kZeroThreshold) return [];
  if (op === '=' && Math.abs(current - distance) <= kZeroThreshold) return [];
  var delta = distance - current; // Sign reflects whether should increase/decrease distance.

  if (!masses) masses = [1, 1];
  if (pq.dot(v) < 0) v.negate();
  var gradq = v.clone().multiplyScalar(delta * masses[0] / (masses[0] + masses[1]));
  var gradp = v.clone().multiplyScalar(-delta * masses[1] / (masses[0] + masses[1]));
  return [new optim_1.Gradient(p, gradp), new optim_1.Gradient(q, gradq)];
}

exports.constrainDistance = constrainDistance;
/**
 * Constrains the position of `q` relative to `p` by some `offset` along the `direction`.
 * @param p
 *     Point vector that serves as the reference.
 * @param q
 *     Point vector that serves as the offset.
 * @param op
 *     Whether to make offset of `q` relative to `p` equal to (`=`), greater than / equal to (`>=`),
 *     or less than / equal to (`<=`) the specified value.
 * @param offset
 *     How much along the direction vector `q` should be relative to `p`. Can be negative.
 * @param direction
 *     Direction vector onto which the offset is projected. Magnitude does not matter.
 * @param masses
 *     Mass of a point determines its inertia, i.e. with more mass it moves less.
 * @returns
 *     Empty array (if already satisfied) or tuple of gradients in order `[p, q]`.
 */

function constrainOffset(p, q, op, offset, direction) {
  var _ref2 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {},
      _ref2$masses = _ref2.masses,
      masses = _ref2$masses === void 0 ? [1, 1] : _ref2$masses;

  var pq = new optim_1.Vector().subVectors(q, p);
  var v = new optim_1.Vector(direction[0], direction[1]).normalize();
  var projected = pq.dot(v);
  if (op === '>=' && projected >= offset + kZeroThreshold) return [];
  if (op === '<=' && projected <= offset - kZeroThreshold) return [];
  if (op === '=' && Math.abs(projected - offset) <= kZeroThreshold) return [];
  var delta = offset - projected;
  var gradq = v.clone().multiplyScalar(delta * masses[0] / (masses[0] + masses[1]));
  var gradp = v.clone().multiplyScalar(-delta * masses[1] / (masses[0] + masses[1]));
  return [new optim_1.Gradient(p, gradp), new optim_1.Gradient(q, gradq)];
}

exports.constrainOffset = constrainOffset;
/**
 * Nudges the angle of the vector pointing from `p` to `q`. The mass of a point determines its
 * inertia i.e. with more mass it moves less. The angle is measured counterclockwise from 0 (as
 * in trigonometry) but since browser's render the positive-y direction pointing downwards, the
 * result may appear opposite than intended if unaccounted for.
 * @param p
 *     Point vector that serves as source (direction tail).
 * @param q
 *     Point vector that serves as target (direction head.).
 * @param angle
 *     Single angle or array of angles, in degrees within range [0, 360].
 * @param strength
 *     Maximum restoring force (felt when points directly opposite the desired angle).
 * @returns
 *     Tuple of gradients in order `[p, q]`.
 */

function nudgeAngle(p, q, angle) {
  var strength = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  var _ref3 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
      _ref3$masses = _ref3.masses,
      masses = _ref3$masses === void 0 ? [1, 1] : _ref3$masses;

  var pq = new optim_1.Vector().subVectors(q, p).normalize();
  var pqAngle = Math.atan2(pq.y, pq.x) * 180 / Math.PI; // In degrees.

  var desired;

  if (Array.isArray(angle)) {
    if (angle.length === 0) throw Error('No angles specified');
    desired = angle[0];
    var mindiff = Number.POSITIVE_INFINITY;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = angle[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var a = _step.value;
        // Positive angular difference in range [0, 180].
        var diff = 180 - Math.abs(Math.abs(a - pqAngle) - 180);

        if (diff < mindiff) {
          desired = a;
          mindiff = diff;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  } else {
    desired = angle;
  } // Signed angular difference in range (-180, 180].


  var sgndiff = (pqAngle - desired - 540) % 360 + 180;
  var delta = strength * sgndiff / 180; // In range (-strength, strength].

  var gradq = new optim_1.Vector(pq.y, -pq.x).multiplyScalar(delta * masses[0] / (masses[0] + masses[1]));
  var gradp = new optim_1.Vector(-pq.y, pq.x).multiplyScalar(delta * masses[1] / (masses[0] + masses[1]));
  return [new optim_1.Gradient(p, gradp), new optim_1.Gradient(q, gradq)];
}

exports.nudgeAngle = nudgeAngle;
/**
 * Nudges the pair of points in opposite directions, away from each other if `magnitude` is
 * positive, and towards each other if the `magnitude` is negative. It is possible to specify
 * different `magnitude` for each point.
 * @param p
 *     Point vector.
 * @param q
 *     Point vector.
 * @param magnitude
 *     Single magnitude or tuple of magnitudes. Nudges away from each other if positive, and
 *     nudges towards each other if negative.
 * @returns
 *     Tuple of gradients in order `[p, q]`.
 */

function nudgePair(p, q, magnitude) {
  if (!Array.isArray(magnitude)) magnitude = [magnitude, magnitude];
  var qp = new optim_1.Vector().subVectors(p, q).normalize();
  var pq = qp.clone().negate();
  qp.multiplyScalar(magnitude[0]);
  pq.multiplyScalar(magnitude[1]);
  return [new optim_1.Gradient(p, qp), new optim_1.Gradient(q, pq)];
}

exports.nudgePair = nudgePair;
/**
 * Nudges a point (or array of points) in the specified `direction` with `magnitude`.
 * @param points
 *     Point vector or array of point vectors.
 * @param magnitude
 *     Magnitude scalar.
 * @param direction
 *     Direction vector, unnormalized.
 * @returns
 *     Array of gradients for each point.
 */

function nudgePoint(points, magnitude, direction) {
  if (!Array.isArray(points)) points = [points];
  var grad = new optim_1.Vector(direction[0], direction[1]).normalize().multiplyScalar(magnitude);
  return points.map(function (p) {
    return new optim_1.Gradient(p, grad.clone());
  });
}

exports.nudgePoint = nudgePoint; // Relative mass of [node, port] determines how much "tug" a port has on its node.

var kPortMasses = [1e6, 1];
/**
 * Constrains `u`'s ports (if any) to be at their correct `location` on the node's boundary,
 * in their correct `order` relative to other ports, if specified. If no port is specified
 * @param u
 *     Node with ports to constrain.
 * @param centering
 *     Strength of port attraction towards center of each side. (default: 0.1)
 * @param gap
 *     Minimum distance between successive ports at a location. (default: 8)
 */

function generateNodePortConstraints(u) {
  var centering,
      gap,
      ports,
      orders,
      _u$center,
      cx,
      cy,
      _u$shape$bounds,
      width,
      height,
      x,
      y,
      X,
      Y,
      _loop,
      _i,
      _ports,
      _ret,
      _args2 = arguments;

  return _regeneratorRuntime.wrap(function generateNodePortConstraints$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          centering = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 0.5;
          gap = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : 8;
          ports = Object.values(u.ports); // Aggregate all ports at the same specified location.

          orders = {
            north: [],
            south: [],
            east: [],
            west: [],
            boundary: [],
            center: []
          };
          ports.forEach(function (port) {
            if (port.order !== undefined) {
              orders[port.location].push(port);
            }
          });
          _u$center = u.center, cx = _u$center.x, cy = _u$center.y;
          _u$shape$bounds = u.shape.bounds(), width = _u$shape$bounds.width, height = _u$shape$bounds.height, x = _u$shape$bounds.x, y = _u$shape$bounds.y, X = _u$shape$bounds.X, Y = _u$shape$bounds.Y;
          _loop =
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _loop() {
            var _ref4, location, order, point, side, ray, risingNormalDot, fallingNormalDot, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref6, p, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, port;

            return _regeneratorRuntime.wrap(function _loop$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _ref4 = _ports[_i];
                    location = _ref4.location;
                    order = _ref4.order;
                    point = _ref4.point;

                    if (!(location === 'center')) {
                      _context.next = 8;
                      break;
                    }

                    _context.next = 7;
                    return constrainDistance(u.center, point, "=", 0, {
                      masses: kPortMasses
                    });

                  case 7:
                    return _context.abrupt("return", "continue");

                  case 8:
                    side = void 0;

                    if (location === 'boundary') {
                      // Narrow down location that the point is currently on.
                      ray = new optim_1.Vector().subVectors(point, u.center);
                      risingNormalDot = ray.x * -height + ray.y * -width;
                      fallingNormalDot = ray.x * height + ray.y * -width;

                      if (risingNormalDot > 0) {
                        side = fallingNormalDot > 0 ? 'north' : 'west';
                      } else {
                        side = fallingNormalDot > 0 ? 'east' : 'south';
                      }
                    } else {
                      side = location;
                    } // Constrain port to `Shape` boundary.


                    _context.next = 12;
                    return u.shape.constrainPointOnBoundary(point, {
                      masses: {
                        shape: 1000,
                        point: 1
                      },
                      offset: 0
                    });

                  case 12:
                    _context.t0 = side;
                    _context.next = _context.t0 === 'north' ? 15 : _context.t0 === 'south' ? 20 : _context.t0 === 'west' ? 25 : _context.t0 === 'east' ? 30 : 35;
                    break;

                  case 15:
                    _context.next = 17;
                    return constrainOffset(u.center, point, "=", -height / 2, [0, 1], {
                      masses: kPortMasses
                    });

                  case 17:
                    _context.next = 19;
                    return nudgePoint(point, centering * (u.center.x - point.x), [1, 0]);

                  case 19:
                    return _context.abrupt("break", 35);

                  case 20:
                    _context.next = 22;
                    return constrainOffset(u.center, point, "=", height / 2, [0, 1], {
                      masses: kPortMasses
                    });

                  case 22:
                    _context.next = 24;
                    return nudgePoint(point, centering * (u.center.x - point.x), [1, 0]);

                  case 24:
                    return _context.abrupt("break", 35);

                  case 25:
                    _context.next = 27;
                    return constrainOffset(u.center, point, "=", -width / 2, [1, 0], {
                      masses: kPortMasses
                    });

                  case 27:
                    _context.next = 29;
                    return nudgePoint(point, centering * (u.center.y - point.y), [0, 1]);

                  case 29:
                    return _context.abrupt("break", 35);

                  case 30:
                    _context.next = 32;
                    return constrainOffset(u.center, point, "=", width / 2, [1, 0], {
                      masses: kPortMasses
                    });

                  case 32:
                    _context.next = 34;
                    return nudgePoint(point, centering * (u.center.y - point.y), [0, 1]);

                  case 34:
                    return _context.abrupt("break", 35);

                  case 35:
                    // Maintain separation gap between ports.
                    // TODO: Make into a scheduled value.
                    _iteratorNormalCompletion2 = true;
                    _didIteratorError2 = false;
                    _iteratorError2 = undefined;
                    _context.prev = 38;
                    _iterator2 = ports.filter(function (_ref7) {
                      var location = _ref7.location,
                          p = _ref7.point;
                      return location !== 'center' && p !== point;
                    })[Symbol.iterator]();

                  case 40:
                    if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                      _context.next = 48;
                      break;
                    }

                    _ref6 = _step2.value;
                    p = _ref6.point;
                    _context.next = 45;
                    return constrainDistance(point, p, '>=', gap);

                  case 45:
                    _iteratorNormalCompletion2 = true;
                    _context.next = 40;
                    break;

                  case 48:
                    _context.next = 54;
                    break;

                  case 50:
                    _context.prev = 50;
                    _context.t1 = _context["catch"](38);
                    _didIteratorError2 = true;
                    _iteratorError2 = _context.t1;

                  case 54:
                    _context.prev = 54;
                    _context.prev = 55;

                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                      _iterator2.return();
                    }

                  case 57:
                    _context.prev = 57;

                    if (!_didIteratorError2) {
                      _context.next = 60;
                      break;
                    }

                    throw _iteratorError2;

                  case 60:
                    return _context.finish(57);

                  case 61:
                    return _context.finish(54);

                  case 62:
                    ; // Only location zones and ordering for more specific sides.

                    if (!(location === 'boundary')) {
                      _context.next = 65;
                      break;
                    }

                    return _context.abrupt("return", {
                      v: void 0
                    });

                  case 65:
                    if (!(order !== undefined)) {
                      _context.next = 93;
                      break;
                    }

                    _iteratorNormalCompletion3 = true;
                    _didIteratorError3 = false;
                    _iteratorError3 = undefined;
                    _context.prev = 69;
                    _iterator3 = orders[location][Symbol.iterator]();

                  case 71:
                    if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                      _context.next = 79;
                      break;
                    }

                    port = _step3.value;

                    if (!(order < port.order)) {
                      _context.next = 76;
                      break;
                    }

                    _context.next = 76;
                    return constrainOffset(point, port.point, ">=", gap, location === 'north' || location === 'south' ? [1, 0] : [0, 1]);

                  case 76:
                    _iteratorNormalCompletion3 = true;
                    _context.next = 71;
                    break;

                  case 79:
                    _context.next = 85;
                    break;

                  case 81:
                    _context.prev = 81;
                    _context.t2 = _context["catch"](69);
                    _didIteratorError3 = true;
                    _iteratorError3 = _context.t2;

                  case 85:
                    _context.prev = 85;
                    _context.prev = 86;

                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                      _iterator3.return();
                    }

                  case 88:
                    _context.prev = 88;

                    if (!_didIteratorError3) {
                      _context.next = 91;
                      break;
                    }

                    throw _iteratorError3;

                  case 91:
                    return _context.finish(88);

                  case 92:
                    return _context.finish(85);

                  case 93:
                  case "end":
                    return _context.stop();
                }
              }
            }, _loop, null, [[38, 50, 54, 62], [55,, 57, 61], [69, 81, 85, 93], [86,, 88, 92]]);
          });
          _i = 0, _ports = ports;

        case 9:
          if (!(_i < _ports.length)) {
            _context2.next = 21;
            break;
          }

          return _context2.delegateYield(_loop(), "t0", 11);

        case 11:
          _ret = _context2.t0;
          _context2.t1 = _ret;
          _context2.next = _context2.t1 === "continue" ? 15 : 16;
          break;

        case 15:
          return _context2.abrupt("continue", 18);

        case 16:
          if (!(typeof _ret === "object")) {
            _context2.next = 18;
            break;
          }

          return _context2.abrupt("return", _ret.v);

        case 18:
          _i++;
          _context2.next = 9;
          break;

        case 21:
          ;

        case 22:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked);
}

exports.generateNodePortConstraints = generateNodePortConstraints;
/**
 *
 * @param u
 *     First node of pair to ensure nonoverlap.
 * @param v
 *     Second node of pair to ensure nonoverlap.
 * @param margin
 *     Spacing outside each node's boundary.
 */

function constrainNodeNonoverlap(u, v) {
  var margin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  // TODO: Rewrite using collision checker
  var _u$shape$bounds2 = u.shape.bounds(),
      ux = _u$shape$bounds2.x,
      uy = _u$shape$bounds2.y,
      uX = _u$shape$bounds2.X,
      uY = _u$shape$bounds2.Y,
      uwidth = _u$shape$bounds2.width,
      uheight = _u$shape$bounds2.height;

  var _v$shape$bounds = v.shape.bounds(),
      vx = _v$shape$bounds.x,
      vy = _v$shape$bounds.y,
      vX = _v$shape$bounds.X,
      vY = _v$shape$bounds.Y,
      vwidth = _v$shape$bounds.width,
      vheight = _v$shape$bounds.height;

  var ubounds = new three_1.Box2(new optim_1.Vector(ux - margin, uy - margin), new optim_1.Vector(uX + margin, uY + margin));
  var vbounds = new three_1.Box2(new optim_1.Vector(vx - margin, vy - margin), new optim_1.Vector(vX + margin, vY + margin));
  if (!ubounds.intersectsBox(vbounds)) return [];
  var xgrad = constrainDistance(u.center, v.center, ">=", (uwidth + vwidth) / 2 + 2 * margin, {
    axis: [1, 0]
  });
  var ygrad = constrainDistance(u.center, v.center, ">=", (uheight + vheight) / 2 + 2 * margin, {
    axis: [0, 1]
  });

  if (xgrad.length !== 0 && ygrad.length !== 0) {
    var xgradlen = xgrad[0].grad.length() + xgrad[1].grad.length();
    var ygradlen = ygrad[0].grad.length() + ygrad[1].grad.length();
    return xgradlen < ygradlen ? xgrad : ygrad;
  } else {
    return [];
  }
}

exports.constrainNodeNonoverlap = constrainNodeNonoverlap;
/**
 *
 * @param nodes
 * @param axis
 */

function generateNodeAlignmentConstraints(nodes, axis) {
  var align,
      _axis,
      x,
      y,
      grads,
      i,
      u,
      v,
      p,
      q,
      _grads,
      _grads2,
      pgrad,
      qgrad,
      _args3 = arguments;

  return _regeneratorRuntime.wrap(function generateNodeAlignmentConstraints$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          align = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : 'center';
          // TODO: Integrate align.
          _axis = _slicedToArray(axis, 2), x = _axis[0], y = _axis[1];

          if (!(nodes.length < 2)) {
            _context3.next = 4;
            break;
          }

          return _context3.abrupt("return");

        case 4:
          grads = [];
          i = 0;

        case 6:
          if (!(i < nodes.length - 1)) {
            _context3.next = 38;
            break;
          }

          // TODO: Integrate fixed.
          u = nodes[i];
          v = nodes[i + 1];
          p = u.center.clone();
          q = v.center.clone();
          _context3.t0 = align;
          _context3.next = _context3.t0 === 'north' ? 14 : _context3.t0 === 'south' ? 17 : _context3.t0 === 'east' ? 20 : _context3.t0 === 'west' ? 23 : 26;
          break;

        case 14:
          p.y += u.shape.support(new optim_1.Vector(0, -1)).sub(u.center).y;
          q.y += v.shape.support(new optim_1.Vector(0, -1)).sub(v.center).y;
          return _context3.abrupt("break", 26);

        case 17:
          p.y += u.shape.support(new optim_1.Vector(0, 1)).sub(u.center).y;
          q.y += v.shape.support(new optim_1.Vector(0, 1)).sub(v.center).y;
          return _context3.abrupt("break", 26);

        case 20:
          p.x += u.shape.support(new optim_1.Vector(0, 1)).sub(u.center).x;
          q.x += v.shape.support(new optim_1.Vector(0, 1)).sub(v.center).x;
          return _context3.abrupt("break", 26);

        case 23:
          p.x += u.shape.support(new optim_1.Vector(0, -1)).sub(u.center).x;
          q.x += v.shape.support(new optim_1.Vector(0, -1)).sub(v.center).x;
          return _context3.abrupt("break", 26);

        case 26:
          _grads = constrainDistance(p, q, '=', 0, {
            axis: [-y, x]
          });

          if (!(_grads.length === 0)) {
            _context3.next = 32;
            break;
          }

          _context3.next = 30;
          return [];

        case 30:
          _context3.next = 35;
          break;

        case 32:
          _grads2 = _slicedToArray(_grads, 2), pgrad = _grads2[0], qgrad = _grads2[1];
          _context3.next = 35;
          return [new optim_1.Gradient(u.center, pgrad.grad), new optim_1.Gradient(v.center, qgrad.grad)];

        case 35:
          i++;
          _context3.next = 6;
          break;

        case 38:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked2);
}

exports.generateNodeAlignmentConstraints = generateNodeAlignmentConstraints;
/**
 * Constraint two nodes such that the distance between their support points along a given axis obeys a given inequality.
 * @param u
 * @param v
 * @param op
 * @param separation
 * @param config
 */

function constrainNodeDistance(u, v, op, distance) {
  var _ref8 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
      _ref8$axis = _ref8.axis,
      axis = _ref8$axis === void 0 ? undefined : _ref8$axis,
      _ref8$masses = _ref8.masses,
      masses = _ref8$masses === void 0 ? [1, 1] : _ref8$masses;

  // TODO: Integrate fixed;
  var supportAxis = new optim_1.Vector().subVectors(v.center, u.center);
  var us = u.shape.support(supportAxis);
  var vs = v.shape.support(supportAxis.negate());
  var grads = constrainDistance(us, vs, op, distance, {
    axis: axis,
    masses: masses
  });
  if (grads.length === 0) return [];

  var _grads3 = _slicedToArray(grads, 2),
      ugrad = _grads3[0],
      vgrad = _grads3[1];

  return [new optim_1.Gradient(u.center, ugrad.grad), new optim_1.Gradient(v.center, vgrad.grad)];
}

exports.constrainNodeDistance = constrainNodeDistance;
/**
 * Constraint two nodes such that the distance between their support points along a given axis obeys a given inequality.
 * @param u
 * @param v
 * @param op
 * @param separation
 * @param config
 */

function constrainNodeOffset(u, v, op, offset, direction) {
  var _ref9 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {},
      _ref9$masses = _ref9.masses,
      masses = _ref9$masses === void 0 ? [1, 1] : _ref9$masses;

  // TODO: Integrate fixed;
  var axis = _construct(optim_1.Vector, _toConsumableArray(direction));

  var us = u.shape.support(axis);
  var vs = v.shape.support(axis.negate());
  var grads = constrainOffset(us, vs, op, offset, direction, {
    masses: masses
  });
  if (grads.length === 0) return [];

  var _grads4 = _slicedToArray(grads, 2),
      ugrad = _grads4[0],
      vgrad = _grads4[1];

  return [new optim_1.Gradient(u.center, ugrad.grad), new optim_1.Gradient(v.center, vgrad.grad)];
}

exports.constrainNodeOffset = constrainNodeOffset;
/**
 *
 * @param u
 * @param v
 */

function constrainNodeCircular(nodes) {
  var radius = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  // TODO
  return [];
}

exports.constrainNodeCircular = constrainNodeCircular;
/**
 *
 * @param u
 * @param dx
 * @param dy
 */

function constrainNodeGrid(u, dx, dy) {
  var snapx = Math.floor(u.center.x / dx) * dx;
  var snapy = Math.floor(u.center.y / dy) * dy;
  return constrainDistance(u.center, new optim_1.Vector(snapx, snapy), "=", 0);
}

exports.constrainNodeGrid = constrainNodeGrid;
/**
 * Apply the specified gradient to all the descendants of `u`.
 * @param u
 * @param grad
 */

function applyGradientToDescendants(u, grad) {
  var grads = [];

  function apply(n, g) {
    if (n.children.length > 0) {
      n.children.forEach(function (c) {
        grads.push(new optim_1.Gradient(c.center, g));
        apply(c, g);
      });
    }
  }

  apply(u, grad.grad);
  return grads;
}

exports.applyGradientToDescendants = applyGradientToDescendants;